import React, { useState } from "react";
import Navbar from "../components/NavBar";
import '../styles/Home.css';



import { FaTruckMoving, FaShieldAlt, FaMoneyBillWave, FaClock } from "react-icons/fa";
import { FaFacebookF, FaInstagram } from 'react-icons/fa';   
import { SiTiktok } from 'react-icons/si';


import posterImg from "../assets/Hero-Images/Poster-Hero.jpg"
import residentialImg from "../assets/Hero-Images/residential.jpeg";
import officeImg from "../assets/Hero-Images/Office.jpeg";
import preMoveImg from "../assets/Hero-Images/Pre-move.jpeg";
import postMoveImg from "../assets/Hero-Images/Post-move.jpeg";
import packingImg from "../assets/Hero-Images/Packing.jpeg";

function Home() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    from: "",
    to: "",
    date: "",
    details: "",
  });

  const handleQuoteSubmit = (e) => {
  e.preventDefault(); // prevent page reload

  const { name, phone, from, to, date, details } = formData;

  const message = `New Quote Submitted:
    Name: ${name}
    Phone: ${phone}
    From: ${from}
    To: ${to}
    Date: ${date}
    Details: ${details}`;

  const adminNumber = "254701133430"; // no + or 0
  const whatsappURL = `https://wa.me/${adminNumber}?text=${encodeURIComponent(message)}`;

  window.open(whatsappURL, "_blank"); // opens WhatsApp in new tab

   setFormData({
    name: "",
    phone: "",
    from: "",
    to: "",
    date: "",
    details: "",
  });
};
  return (
    <>
      <Navbar />

      <section className="hero">
        <div className="hero-overlay">
          <div className="hero-poster-div">
            <img 
                src={posterImg} 
                alt="Promo Poster" 
                className="hero-poster"
              />
          </div>
          <div className="hero-content">
             <h1 className="hero-title">Reliable Moving & Logistics Solutions</h1>
            <p className="hero-subtitle">
              Fast, safe, and professional moving services tailored for you.
            </p>
            <div className="hero-buttons">
              <button className="cta-btn"
                      onClick={() => document.getElementById("quote").scrollIntoView({ behavior: "smooth" })}>
                        Get a Quote</button>
              <button className="cta-btn-outline"
                      onClick={() => document.getElementById("footer").scrollIntoView({ behavior: "smooth"})
                        
                      } 

                      >Learn More</button>
            </div>
          </div>
        </div>
      </section>
      <section className="services" id="services">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <img src={residentialImg} alt="Residential Moving" />
            <h3>Residential Moving</h3>
            <p>Safe and efficient moving services for homes of all sizes.</p>
          </div>
          <div className="service-card">
            <img src={officeImg} alt="Office Relocation" />
            <h3>Office Relocation</h3>
            <p>Professional and timely relocation services for your office or business.</p>
          </div>
          <div className="service-card">
            <img src={preMoveImg} alt="Pre-Move Cleaning" />
            <h3>Pre-Move Cleaning</h3>
            <p>Thorough cleaning of your property before the move for a fresh start.</p>
          </div>
          <div className="service-card">
            <img src={postMoveImg} alt="Post-Move Cleaning" />
            <h3>Post-Move Cleaning</h3>
            <p>Complete cleaning services after moving in to make your space spotless.</p>
          </div>
          <div className="service-card">
            <img src={packingImg} alt="Packing & Unpacking" />
            <h3>Packing & Unpacking</h3>
            <p>Professional packing and unpacking services to protect your belongings.</p>
          </div>
          </div>
        </section>
        
        <section className="why-us">
          <h2 className="section-title">Why Choose AMF Movers</h2>

          <div className="why-grid">

          <div className="why-card">
            <FaTruckMoving className="why-icon" />
            <h3>Experienced Team</h3>
            <p>Our trained movers handle your belongings with professionalism and care.</p>
          </div>

          <div className="why-card">
            <FaShieldAlt className="why-icon" />
            <h3>Safe & Secure</h3>
            <p>We use proper equipment and techniques to ensure everything arrives safely.</p>
          </div>

          <div className="why-card">
            <FaMoneyBillWave className="why-icon" />
            <h3>Affordable Pricing</h3>
            <p>Transparent pricing with no hidden charges for your moving services.</p>
          </div>

          <div className="why-card">
            <FaClock className="why-icon" />
            <h3>Reliable Service</h3>
            <p>We pride ourselves on punctuality and delivering your items on time.</p>
          </div>

        </div>
      </section>


      <section className="process">
        <h2 className="section-title">How Our Moving Process Works</h2>

        <div className="process-grid">

        <div className="process-card">
          <div className="process-number">1</div>
          <h3>Request a Quote</h3>
          <p>Tell us your moving details and receive a quick and transparent quote.</p>
        </div>

        <div className="process-card">
          <div className="process-number">2</div>
          <h3>We Plan Your Move</h3>
          <p>Our team organizes packing, transportation, and scheduling for a smooth move.</p>
        </div>

        <div className="process-card">
          <div className="process-number">3</div>
          <h3>Safe Delivery</h3>
          <p>Your belongings are transported safely and delivered on time.</p>
        </div>

      </div>
    </section>

    <section className="quote" id="quote">
      <div className="quote-container">

      <div className="quote-text">
        <h2>Get Your Free Moving Quote</h2>
        <p>
          Planning a move? Fill out the form and our team will get back to you
          quickly with a personalized moving quote.
        </p>
      </div>

      <div className="quote-form-container">
        <h4>Fill details to request service</h4>
        <form className="quote-form"  onSubmit={handleQuoteSubmit}>
          <input 
              type="text" 
              name="name"
              placeholder="Full Name"
              required
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})} />
          <input 
              type="tel" 
              name="phone"
              placeholder="Phone Number"
              required
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})} />
          <input 
              type="text" 
              name="from"
              placeholder="Moving From" 
              required
              value={formData.from}
              onChange={(e) => setFormData({...formData, from: e.target.value})} />
          <input 
              type="text" 
              name="to"
              placeholder="Moving To" 
              required
              value={formData.to}
              onChange={(e) => setFormData({...formData, to: e.target.value})} />
          <input 
              type="date" 
              name="date"
              required
              value={formData.date}
              onChange={(e) => setFormData({...formData, date: e.target.value})} /> 

          <textarea 
              name="details"
              placeholder="Additional Details (optional)" 
              rows="4"
              value={formData.details}
              onChange={(e) => setFormData({...formData, details: e.target.value})} ></textarea>

          <button type="submit" className="quote-btn">
            Request Quote
          </button>
        </form>
      </div>

    </div>
  </section>

      <footer className="footer" id="footer">
        <div className="footer-container">

        {/* About Section */}
        <div className="footer-section">
          <h3>AMF Movers</h3>
          <p>
            Reliable moving & logistics solutions. Fast, safe, and professional services
            tailored for you.
          </p>
        </div>

        {/* Services Links */}
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li>Residential Moving</li>
            <li>Office Relocation</li>
            <li>Pre-Move Cleaning</li>
            <li>Post-Move Cleaning</li>
            <li>Packing & Unpacking</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Phone: +254 701 133 430</p>
          <p>Phone: +254 756 898 851</p>
          <p>Email: amfcargotransporters@gmail.com</p>
          <p>Location: Nairobi, Kenya</p>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/17wk8Q1yDm/" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/amf_movers/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://vm.tiktok.com/ZS984fy3TuMUR-Dq7Hm/" target="_blank" rel="noopener noreferrer">
              <SiTiktok />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 AMF Movers. All rights reserved.</p>
      </div>
    </footer>
    </>
  );
}

export default Home; 

